module.exports = __webpack_public_path__ + "media/images/ticket/ticket_complete_banner-4c71017f547ec335ed677b5ad13b5f0c.png";